
import { aboutImages } from '../../../utils/images';

export default function ValuesSection() {
  const values = [
    {
      title: "Quality",
      description: "Excellence in every product delivered.",
      icon: "ri-star-line",
      color: "bg-blue-100 text-blue-600"
    },
    {
      title: "Innovation", 
      description: "Advanced materials and processes to stay ahead of trends.",
      icon: "ri-lightbulb-line",
      color: "bg-green-100 text-green-600"
    },
    {
      title: "Sustainability",
      description: "Certified, ethical, and responsible practices.",
      icon: "ri-leaf-line",
      color: "bg-teal-100 text-teal-600"
    },
    {
      title: "Reliability",
      description: "Consistency, transparency, and long-term collaboration.",
      icon: "ri-shield-check-line",
      color: "bg-purple-100 text-purple-600"
    }
  ];

  return (
    <section className="py-20 bg-gray-50 pb-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            What Drives Us
          </div>
          <h2 className="text-5xl lg:text-6xl font-light mb-8 leading-tight">
            Our{' '}
            <span className="font-normal">
              Values
            </span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed font-light max-w-3xl mx-auto">
            At Musheng, we believe in more than manufacturing—we believe in partnership. Four principles guide our business:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white p-8 text-center">
              <div className={`w-16 h-16 flex items-center justify-center rounded-full ${value.color} mx-auto mb-6`}>
                <i className={`${value.icon} text-2xl`}></i>
              </div>
              <h3 className="text-2xl font-light mb-4">{value.title}</h3>
              <p className="text-gray-700 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <h3 className="text-3xl font-light mb-6">Partnership Beyond Manufacturing</h3>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            These values are not just words—they are the foundation of every relationship we build, every product we create, and every solution we deliver for our global partners.
          </p>
        </div>
      </div>
    </section>
  );
}
